import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface Meeting {
  id: string;
  meeting_type: string;
  scheduled_date: string;
  other_person_name: string;
  is_observer: boolean;
}

interface UpcomingMeetingsWidgetProps {
  meetings: Meeting[];
  loading?: boolean;
}

export function UpcomingMeetingsWidget({ meetings, loading }: UpcomingMeetingsWidgetProps) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            Upcoming Meetings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Upcoming Meetings ({meetings.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {meetings.length === 0 ? (
          <p className="text-sm text-muted-foreground">No upcoming meetings</p>
        ) : (
          <div className="space-y-3">
            {meetings.slice(0, 3).map((meeting) => (
              <div key={meeting.id} className="flex items-start justify-between border-b pb-2 last:border-0">
                <div className="flex-1">
                  <p className="font-medium text-sm capitalize">{meeting.meeting_type.replace('_', ' ')}</p>
                  <p className="text-xs text-muted-foreground">
                    {meeting.is_observer ? 'With' : 'Led by'}: {meeting.other_person_name}
                  </p>
                  <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                    <Clock className="h-3 w-3" />
                    {new Date(meeting.scheduled_date).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
            {meetings.length > 3 && (
              <Button 
                variant="link" 
                size="sm" 
                className="w-full"
                onClick={() => navigate('/meeting-tracker')}
              >
                View all {meetings.length} meetings
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
